import { useTranslation } from "react-i18next";
import SvgContainer from "src/components/SvgContainer";
import { Box, Flex } from "@chakra-ui/react";
import { Subtitle2 } from "src/atoms/typography";
import { webLinks } from "src/browser/web-links";
import { ReactComponent as SettingsIcon } from "./settings.svg";
import { ReactComponent as PremiumIcon } from "./start-outlined.svg";
import { ReactComponent as ExploreIcon } from "./explore.svg";
import { ReactComponent as ActivityLogIcon } from "src/icons/activitylog.svg";
import { useSelector } from "react-redux";
import { hasPremium } from "src/modules/auth/duck/selectors";
import openExternal from "src/utils/openExternal";

const Divider = () => {
  return <Box bg="lowEmphasis" width="1px" height="14px" />;
};

export default function Tabs({ openPremium, openSettings, openActivityLog }) {
  const isPremium = useSelector(hasPremium);
  const { t } = useTranslation();

  return (
    <Flex
      pos="fixed"
      top="6px"
      left="50%"
      transform="translateX(-50%)"
      alignItems="center"
      columnGap="12px"
      sx={{
        svg: { path: { fill: "mediumEmphasis" } },
        button: {
          px: "6px",
          py: "8px",
          borderRadius: "32px",
          transition: "background-color 0.3s",
          whiteSpace: "nowrap",
          _hover: {
            bg: "hover"
          }
        },
        p: {
          fontSize: "clamp(1.2rem, 2.29vmin, 1.6rem)"
        }
      }}
    >
      <Flex columnGap="6px" as="button" alignItems="center" onClick={openActivityLog}>
        <SvgContainer size="clamp(1.6rem, 2.29vmin, 1.6rem)" icon={ActivityLogIcon} />
        <Subtitle2>{t("activityLog.heading")}</Subtitle2>
      </Flex>

      <Divider />

      <Flex columnGap="6px" as="button" alignItems="center" onClick={() => openExternal({ url: webLinks.explore })}>
        <SvgContainer size="clamp(1.6rem, 2.29vmin, 1.6rem)" icon={ExploreIcon} />
        <Subtitle2>{t("menu.explore")}</Subtitle2>
      </Flex>

      <Divider />

      {!isPremium && (
        <>
          <Flex columnGap="6px" as="button" alignItems="center" onClick={openPremium}>
            <SvgContainer size="clamp(1.6rem, 2.29vmin, 1.6rem)" icon={PremiumIcon} />
            <Subtitle2>{t("menu.premium")}</Subtitle2>
          </Flex>
          <Divider />
        </>
      )}

      <Flex
        columnGap="6px"
        as="button"
        alignItems="center"
        onClick={openSettings}
        sx={{ svg: { fill: "mediumEmphasis" } }}
      >
        <SvgContainer size="clamp(1.6rem, 2.29vmin, 1.6rem)" icon={SettingsIcon} />
        <Subtitle2>{t("settings")}</Subtitle2>
      </Flex>
    </Flex>
  );
}
